import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { publishCardMessages } from '../publish-messages';

type Props = {
  open: boolean;
  platformName: string;
  isDeleting: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
};

/**
 * Confirm dialog for deleting a completed upload from the social platform.
 */
export function UploadCardDeleteDialog({
  open,
  platformName,
  isDeleting,
  onClose,
  onConfirm,
}: Props) {
  const { $t } = useIntl();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {$t(publishCardMessages.deleteVideoFromPlatformTitle, {
          platform: platformName,
        })}
      </DialogTitle>
      <DialogContent>
        <FormattedMessage {...publishCardMessages.deleteVideoFromPlatformMessage} />
      </DialogContent>
      <DialogActions sx={{ padding: 2 }}>
        <Button onClick={onClose}>
          {$t({
            id: 'common.cancel',
            defaultMessage: 'Cancelar',
          })}
        </Button>
        <Button
          color="error"
          variant="contained"
          disabled={isDeleting}
          onClick={async () => {
            await onConfirm();
            onClose();
          }}
        >
          {$t({
            id: 'common.delete',
            defaultMessage: 'Eliminar',
          })}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
